import { EViolinStatus } from './e-violin';

export const EViolinTextColorClasses: { [key: string]: string } = {
  [EViolinStatus.ACTIVE]: 'text-eVactive-500',
  [EViolinStatus.AVAILABLE]: 'text-eVavailable-500',
  [EViolinStatus.CHARGING]: 'text-eVcharging-500',
  [EViolinStatus.ERROR]: 'text-eVerror-500',
  [EViolinStatus.FULLY_CHARGED]: 'text-eVfullyCharged-500',
  [EViolinStatus.INACTIVE]: 'text-eVinactive-500'
};

export const EViolinBorderColorClasses: { [key: string]: string } = {
  [EViolinStatus.ACTIVE]: 'border-eVactive-500',
  [EViolinStatus.AVAILABLE]: 'border-eVavailable-500',
  [EViolinStatus.CHARGING]: 'border-eVcharging-500',
  [EViolinStatus.ERROR]: 'border-eVerror-500',
  [EViolinStatus.FULLY_CHARGED]: 'border-eVfullyCharged-500',
  [EViolinStatus.INACTIVE]: 'border-eVinactive-500'
};

export const EViolinBackgroundColorClasses: { [key: string]: string } = {
  [EViolinStatus.ACTIVE]: 'bg-eVactive-500',
  [EViolinStatus.AVAILABLE]: 'bg-eVavailable-500',
  [EViolinStatus.CHARGING]: 'bg-eVcharging-500',
  [EViolinStatus.ERROR]: 'bg-eVerror-500',
  [EViolinStatus.FULLY_CHARGED]: 'bg-eVfullyCharged-500',
  [EViolinStatus.INACTIVE]: 'bg-eVinactive-500'
};
